import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/PaymentResult.css';

const PaymentError = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const error = params.get('error') || 'Ödeme işlemi sırasında bir hata oluştu';
    const orderId = params.get('orderId');

    return (
        <div className="payment-result-container error">
            <div className="error-icon">✕</div>
            <h2>Ödeme Başarısız</h2>
            <p className="error-message">{decodeURIComponent(error)}</p>
            
            {orderId && (
                <p className="order-reference">
                    Sipariş Referans No: {orderId}
                </p>
            )}

            <div className="action-buttons">
                <button onClick={() => navigate('/cart')} className="primary">
                    Sepete Dön
                </button>
                <button onClick={() => navigate('/')} className="secondary">
                    Ana Sayfaya Dön
                </button>
            </div>

            <div className="help-text">
                <p>Eğer hesabınızdan para çekildiyse, 24 saat içinde iade edilecektir.</p>
                <p>Sorun devam ederse lütfen müşteri hizmetleri ile iletişime geçin.</p>
            </div>
        </div>
    );
};

export default PaymentError; 